import Http from "./http";

export const triggerWelcomeEmailAPI = (data, options) => {
    return Http.post("admin/triggerWelcomeNotification", data, options);
};
